import Highcharts from 'highcharts';

export const globalChartOptions: Highcharts.Options = {
  lang: {
    rangeSelectorZoom: '',
    contextButtonTitle: '',
  },
};
